import Service from './Service';
import GeneralUtils from "../utils/GeneralUtils";
import {SERVER_URL} from "../utils/Constants";

export default class RatingService extends Service {
    constructor() {
        super();
        this.baseURL = 'calculateRating';
    }

    calculateRating = (month, year) => {
        return fetch(SERVER_URL + this.baseURL+ '/calculateRating/'+month+'/'+year, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return result.json();
        }).catch(error => {
        GeneralUtils.notification(error);
        });
    }

    lockPeriod = (month, year) => {
        return fetch(SERVER_URL + this.baseURL+ '/lockPeriod/'+month+'/'+year, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return result.json();
        }).catch(error => {
        GeneralUtils.notification(error);
        });
    }

    isPeriodLocked = (month, year) => {
        return fetch(SERVER_URL + this.baseURL +'/'+month+'/'+year, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => {
            let result = response.clone();
            return result.json();
        }).catch(error => {
        GeneralUtils.notification(error);
        });
    }
    
}